/**
 * `fxRates.*` contract — read-only FX reference rates (migration 0059).
 *
 * The invoice composer reads this to suggest the booked rate on export
 * invoices instead of a hard-coded value.
 */
import { z } from "zod";

export const fxRateRow = z.object({
  baseCurrency: z.string(),
  quoteCurrency: z.string(),
  /** Stringified bigint — INR paise per 1 unit of `baseCurrency`. */
  ratePaise: z.string(),
  asOfDate: z.string(),
});

export const listOutput = z.array(fxRateRow);
